import { createStatePropertySelector } from "../../../helpers";
import { selectSignalsSlice } from "../../../store/selectors";

const select = createStatePropertySelector(selectSignalsSlice);

export const selectSignalsUse = select("signalsUse");
export const selectActiveSignalFilterId = select("selectedFilterId");
export const selectActiveSignalSubFilterId = select("selectedSubFilterId");
export const selectActiveSignalsTab = select("activeTabIndex");
